// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"133":"2679eee7","494":"2679eee7"}[chunkId] + ".css";
};